'use client';
import * as Popover from '@radix-ui/react-popover';
import { IoIosNotificationsOutline } from 'react-icons/io';
import { IoCloseOutline } from 'react-icons/io5';
import { PushNotificationsWidget } from './PushNotificationsWidget';
import { usePush } from '@/common/usePush';

export function NotificationBellButton() {
  const { isPushAviable, askPermission, subscribeButtonOnClick, isSubscribed } =
    usePush(undefined, true);

  if (!isPushAviable) {
    return <div className="w-9" />;
  }

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button className="IconButton" aria-label="Update dimensions">
          <IoIosNotificationsOutline
            size={36}
            className="block cursor-pointer text-white hover:text-tintColorHover"
          />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="PopoverContent max-w-[300px] z-[10001]"
          sideOffset={5}
          align="end"
        >
          <PushNotificationsWidget gapBottom>
            <div className=" w-full flex justify-end">
              <Popover.Close className="PopoverClose" aria-label="Close">
                <IoCloseOutline
                  size={24}
                  className="block cursor-pointer text-white hover:text-primaryColor"
                />
              </Popover.Close>
            </div>
          </PushNotificationsWidget>
          <Popover.Arrow className="PopoverArrow" fill="#A40041" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
